"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base64_1 = require("./base64");
const errorHandler = tslib_1.__importStar(require("./errorHandler"));
const sanitize_1 = require("./sanitize");
class API {
    constructor(settings) {
        this.updateCredentials = (credentials) => {
            this.credentials = credentials;
        };
        this.getDesignData = this.getDocumentData('designs');
        this.getTemplateData = this.getDocumentData('templates');
        this.saveDesignData = this.saveDocumentData('designs');
        this.saveTemplateData = this.saveDocumentData('templates');
        errorHandler.validateApiConstructor(settings);
        this.baseUrl = settings.baseUrl;
        this.bookId = settings.bookId;
        this.credentials = settings.credentials;
    }
    getRequestHeaders() {
        return {
            Accept: 'application/json',
            Authorization: `Basic ${this.credentials}`,
            'Content-Type': 'application/json',
        };
    }
    getCompanyComplement() {
        if (!this.companyId)
            return '';
        return `companies/${this.companyId}/`;
    }
    getDocumentData(type) {
        return () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.baseUrl}brand/${this.getCompanyComplement()}${type}/${this.bookId}`;
            const request = yield fetch(requestUrl, {
                method: 'GET',
                headers: this.getRequestHeaders(),
            });
            return yield request.json();
        });
    }
    setCompanyId(data) {
        var _a;
        const companyId = (_a = data === null || data === void 0 ? void 0 : data.company) === null || _a === void 0 ? void 0 : _a.id;
        if (this.companyId || !companyId)
            return;
        this.companyId = companyId;
    }
    saveDocumentData(type) {
        return (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.baseUrl}brand/${this.getCompanyComplement()}${type}/${this.bookId}`;
            const request = yield fetch(requestUrl, {
                method: 'PUT',
                headers: this.getRequestHeaders(),
                body: JSON.stringify(data),
            });
            return yield request.json();
        });
    }
    saveProjectData(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.baseUrl}business/projects/${this.bookId}`;
            const request = yield fetch(requestUrl, {
                method: 'PATCH',
                headers: this.getRequestHeaders(),
                body: JSON.stringify(data),
            });
            return yield request.json();
        });
    }
    createNewPage(page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            errorHandler.validatePageCreation(page);
            const requestUrl = `${this.baseUrl}business/projects/${this.bookId}/pages`;
            const request = yield fetch(requestUrl, {
                method: 'POST',
                headers: this.getRequestHeaders(),
                body: JSON.stringify(page),
            });
            return yield request.json();
        });
    }
    duplicatePage(page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            errorHandler.validatePageDuplication(page);
            const requestUrl = `${this.baseUrl}business/projects/${this.bookId}/pages`;
            const request = yield fetch(requestUrl, {
                method: 'POST',
                headers: this.getRequestHeaders(),
                body: JSON.stringify(page),
            });
            return yield request.json();
        });
    }
    getPage(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.baseUrl}business/projects/${this.bookId}/pages/${id}`;
            const request = yield fetch(requestUrl, {
                method: 'GET',
                headers: this.getRequestHeaders(),
            });
            return yield request.json();
        });
    }
    savePage(id, content, additionalData) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.baseUrl}business/projects/${this.bookId}/pages/${id}`;
            const request = yield fetch(requestUrl, {
                method: 'PUT',
                headers: this.getRequestHeaders(),
                body: JSON.stringify(Object.assign(Object.assign({}, additionalData), { content: (0, base64_1.encode)((0, sanitize_1.sanitizeContent)(content)) })),
            });
            if (request.status >= 400) {
                throw new Error(request.statusText);
            }
            else if (request.status !== 200) {
                return {
                    ok: request.ok,
                    status: request.status,
                };
            }
            return yield ((_a = request.json) === null || _a === void 0 ? void 0 : _a.call(request));
        });
    }
    deletePage(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.baseUrl}business/projects/${this.bookId}/pages/${id}`;
            const request = yield fetch(requestUrl, {
                method: 'DELETE',
                headers: this.getRequestHeaders(),
            });
            return yield request.json();
        });
    }
}
exports.default = API;
//# sourceMappingURL=api.js.map